import { useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let onComplete = useDataValue({
    context: 'template_override',
    viewPath: props.viewPath,
    path: 'onComplete',
  })
  return function onClick() {
    if (onComplete) {
      onComplete()
    }
  }
}
